import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.less'

createApp(App).mount('#app')
